<template>
    <div id="post-comments-widget">
        <div class="container">
            <div class="row">
                <div class="col-12 col-lg-8">
                    <div class="post__comments">
                        <div class="post__comments-title">{{$store.getters.t('post_comments_title')}}</div>
                        <div class="post__comments-body" v-if="loggedIn">
                            <span @click="showForm = !showForm" class="btn post__comments-toggler">{{$store.getters.t('post_comments_add_comment')}}</span>
                            <transition name="fade" mode="out-in">
                                <div class="post__comments-form" v-show="showForm">
                                    <textarea v-model="commentText" :placeholder="$store.getters.t('post_comments_leave_a_comment')"></textarea>
                                    <div class="text-danger text-left" v-if="$v.commentText.$error">{{$store.getters.t('post_comments_comment_is_required')}}</div>
                                    <span class="btn mt-1 post__comments-submit" @click="handlePostComment">{{$store.getters.t('post_comments_send')}}</span>
                                </div>
                            </transition>
                        </div>
                        <template v-if="comments.length">
                            <ul class="post__comments-list">
                                <li v-for="comment of comments" :key="comment.id" class="d-flex post__comments-list-item">
                                    <a :href="`/user/${comment.user_id}/profile`" class="post__comments-list-avatar">
                                        <img v-if="hasUserAvatar(comment.user)"
                                            :src="`/storage/${comment.user.avatar.path}`.replace('original', 'avatar')" alt=""
                                        >
                                        <span v-else>{{normalizeName(comment.user.name)}}</span>
                                    </a>
                                    <div>
                                        <div class="d-flex post__comments-list-meta">
                                            <a class="post__comments-list-name" :href="`/user/${comment.user_id}/profile`">{{comment.user.name}}</a>
                                            <span v-text="handleDateFormat(comment.created_at)"></span>
                                        </div>
                                        {{ comment.text }}
                                    </div>
                                </li>
                            </ul>

                            <paginate
                                v-model="page"
                                :class="['d-flex', 'justify-content-center', 'mt-3', 'pb-2', 'pagination-area', 'post__comments-pagination']"
                                :page-count="last_page"
                                :click-handler="paginateClickCallback"
                                :prev-text="''"
                                :next-text="''"
                                :container-class="'className'"
                                :page-class="'page-numbers'"
                                :page-link-class="''"
                                :active-class="'current'"
                                :prev-class="'prev page-numbers'"
                                :prev-link-class="'lnr lnr-arrow-left'"
                                :next-class="'next page-numbers'"
                                :next-link-class="'lnr lnr-arrow-right'"
                            >
                            </paginate>

                        </template>
                        <template v-else>
                            <div class="d-flex justify-content-center p-3">
                                {{$store.getters.t('post_comments_list_empty')}}
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { required } from 'vuelidate/lib/validators';
import { postComment, getPostComments } from '../api'
import { mapGetters } from 'vuex'

export default {
    name: "PostComments",
    props: {
        post: { required: true, type: Object }
    },
    data(){
        return{
            showForm: false,
            commentText: null,
            comments: [],
            page: 1,
            last_page: 1
        }
    },

    created(){
        if( this.post.comments_count )
            this.loadPosts()
    },

    computed:{
        ...mapGetters(['loggedIn'])
    },

    methods: {

        normalizeName( name ){
            return name.charAt(0)
        },

        hasUserAvatar( user ){
            return user && user.avatar && user.avatar.path
        },

        handleDateFormat( date ){
            return (date.split('T')[0]).split('-').reverse().join('.')
        },

        async handlePostComment(){
            this.$v.$touch();
            if (this.$v.$invalid) {
                return false;
            }

            const config = {
                commentable_id: this.post.id,
                text: this.commentText
            }

            try{
                const { data: { success = false } } = await postComment( config )
                if( success ){
                    this.commentText = null
                    this.$v.$reset()
                    await this.loadPosts()
                }
            } catch(e){
                console.log(e);
            }

        },

        async loadPosts(){
            try{
                let { data:{ data = [], last_page = 1} } = await getPostComments( this.post.id, { page: this.page, per_page: 5 } )
                if( data.length ){
                    this.comments = data
                    this.last_page = last_page
                }
                
            } catch( e ){
                console.log(e);
            }

        },

        async paginateClickCallback(pageNum) {
            this.page = pageNum;
            await this.loadPosts();
        },

    },

    validations: {
        commentText: {
            required
        }
    }

}
</script>
